<div class="row" *ngIf="data">

    <div class="col-md-9">
        <div class="row">
            <div class="col-12">
                <h2 class="eventTitle">
                    {{data?.event?.event?.name}}
                    
                    <span>{{data?.event?.event?.in_play == 1 ? 'In Play' : data?.event?.event?.open_date | date: 'dd/MM/YYYY hh:mm a'}}</span>

                    <!-- <a class="btn btn-tv-bets mob-tv-icon" href="javascript:void(0)" (click)="tvData('mobile')"
                        [attr.aria-expanded]="!isCollapsed.tv.mobile" aria-controls="collapseBasic">
                        <i class="mdi mdi-television"></i>
                    </a> -->
                    <a class="btn btn-tv-bets mob-tv-icon" href="javascript:void(0)" (click)="tvData('mobile')"
                        [attr.aria-expanded]="!isCollapsed.tv.mobile" aria-controls="collapseBasic">
                        <!-- <img class="img-fluid" src="assets/img/television.png"> -->
                        <i class="mdi mdi-television"></i>
                    </a>
                    <a class="btn btn-tv-bets mob_open_bets" href="javascript:void(0)" (click)="openModal(openBets,'bets')">
                        <span>Bets</span>
                    </a>
                </h2>
            </div>

            <!-- tv mobile -->
            <!-- <div id="collapseBasic" [collapse]="isCollapsed.tv.mobile" [isAnimated]="true">
                <div id="tvStr" class="embed-responsive embed-responsive-16by9 rounded" [innerHTML]="tvSteam | safeHtml">
                </div>
            </div> -->
            <!-- tv mobile -->
            <!-- tv mobile -->
              <div id="collapseBasic" [collapse]="isCollapsed.tv.mobile" [isAnimated]="true">
                <div id="tv-block-id-mob" style="position: relative;" class="tv-block"></div>
                <!-- <div class="tv-block" *ngIf="isCollapsed.tv.mobile == false" style="position: relative;">
                    <iframe class="LiveStream-video-col" id="tvStr" [src]='iframeURL | safeURL'></iframe>
                </div> -->
            </div>
            <!-- tv mobile -->
        </div>

        <div style="margin-bottom: 3px;" class="" *ngIf="scoreHtml != ''" [innerHTML]="scoreHtml | safeHtml"></div>

        <div class="combine-book" *ngIf="data?.event?.event?.in_play == 1 && combineBook.length > 0">
            <span [ngClass]="{'border-show': (i != 0)}" *ngFor="let item of combineBook;let i=index;trackBy:trackByIndex;"> <span class="pm-book" [ngClass]="(item?.expose > 0) ? 'plus-book' : 'minus-book'">{{fixedPostDecimal(item?.expose)}} {{item?.avg != 0 ? '('+ fixedPostDecimal(item?.avg) +')' : ''}}</span></span>
        </div>
        <!-- MATCH ODDS -->
        <div class="dScreen" *ngIf="data?.event?.match_odds?.status == 1">
            <div class="row mx-0 head_bg">
                <div class="col-md-6 col-12 px-0">
                    <p class="match-odds">
                        <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(data?.event?.match_odds?.market_id)" (click)="multiMarketUpdate(data?.event?.match_odds, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                        <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(data?.event?.match_odds?.market_id)" (click)="multiMarketUpdate(data?.event?.match_odds, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                        Match odds
                        <a href="javascript:void(0)" (click)="openModal(ruleModal, 'rule')">
                            <i class="mdi mdi-information-outline"></i>
                        </a>
                        <a href="javascript:void(0)" class="setting" *ngIf="env.host.isMarketSetting" (click)="openSettingModal(data?.event?.match_odds)">
                            <i class="mdi mdi-cog"></i>
                        </a>
                        <a href="javascript:void(0)" class="book" *ngIf="exposLisDis[data?.event?.match_odds?.market_id]"
                        (click)="openBook(data?.event?.match_odds, 'odds')">
                            <i class="mdi mdi-book"></i>
                        </a>
                    </p>
                </div>
                <div class="col-md-6 col text-end px-0 d-inline-block d-lg-none">
                    <!-- <span class="matched-count">Matched
                        <strong>{{oddsLisDis[data?.event?.match_odds?.market_id]?.totalMatched}}</strong></span> -->
                    <!-- <div class="bets-mbl-show"> -->
                    <!-- <a class="btn btn-tv-bets mob-tv-icon" href="javascript:void(0)" (click)="tvData('mobile')"
                        [attr.aria-expanded]="!isCollapsed.tv.mobile" aria-controls="collapseBasic">
                        <i class="mdi mdi-television"></i>
                    </a>
                    <a class="btn btn-tv-bets mob_open_bets" href="javascript:void(0)" (click)="openModal(openBets,'bets')">
                        <span>Bets</span>
                    </a> -->
                    <!-- </div> -->
                </div>
            </div>

            <div class="row mx-0 odds_header">
                <div class="col-md-6 col-7 px-0">
                    <div class="minmax mm-fi">
                        <dl class="fancy-info">
                            <dt>Min/Max</dt>
                            <dd>{{data?.event?.match_odds?.min_bet}}-{{data?.event?.match_odds?.max_bet}}</dd>
                        </dl>
                    </div>
                </div>
                <div class="col-md-6 col px-0">
                    <div class="btn-group dOddsBox">
                        <button class="back2"></button>
                        <button class="back1"></button>
                        <button class="back">back</button>
                        <button class="lay">lay</button>
                        <button class="min-max-bet">
                            <dl class="fancy-info">
                                <dt>Min/Max</dt>
                                <dd>{{data?.event?.match_odds?.min_bet}}-{{data?.event?.match_odds?.max_bet}}</dd>
                            </dl>
                        </button>
                    </div>
                </div>
            </div>
            <div class="row mx-0 odds_body"
                *ngFor="let runner of data?.event?.match_odds?.runners; let i=index;trackBy:trackByIndex;">
                <div class="col-md-6 col-7 px-0">
                    <p class="team-name">
                        {{runner?.name}}
                        <span>
                            <span *ngIf="exposLisDis[runner?.market_id] && exposLisDis[runner?.market_id][runner?.selection_id]"
                                    [ngClass]="exposLisDis[runner?.market_id][runner?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'"
                                    class=""><i class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[runner?.market_id][runner?.selection_id]?.expose)}}
                                    {{(exposLisDis[runner?.market_id][runner?.selection_id]?.average &&
                                    exposLisDis[runner?.market_id][runner?.selection_id]?.average != '') ?
                                    exposLisDis[runner?.market_id][runner?.selection_id]?.average : ''}}
                                    
                                </span>
                                <!-- <span *ngIf="!(exposLisDis[runner?.market_id] && exposLisDis[runner?.market_id][runner?.selection_id])" class="minus-book"><i
                                        class="mdi mdi-arrow-right"></i> 0.00</span> -->
                                <b *ngIf="nextExpoList[runner?.market_id+'-'+ runner?.selection_id]">
                                    <em class="extra-pf"
                                        [ngClass]="{'plus-book': nextExpoList[runner?.market_id+'-'+ runner?.selection_id] > 0, 'minus-book': nextExpoList[runner?.market_id+'-'+ runner?.selection_id] < 0}">({{nextExpoList[runner?.market_id+'-'+
                                        runner?.selection_id]}})</em>
                                </b>
                        </span>

                    </p>
                </div>
                <div class="col-md-6 col px-0">
                    <div class="btn-group dOddsBox">
                        <button class="{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.key}} back  back2" (click)="openBetPlace(data?.event?.match_odds, oddsLisDis[data?.event?.match_odds?.market_id], i, oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2], '2', 'b1', 'match_odds')">
                            <b>
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.price ? oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.price : '-'}}
                            <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.size ? volumeMultiSize(oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.size, data?.event?.match_odds?.volume_multi) : '-'}}</span>
                            </b>
                        </button>
                        <button class="{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.key}} back back1" (click)="openBetPlace(data?.event?.match_odds, oddsLisDis[data?.event?.match_odds?.market_id], i, oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1], '1', 'b2', 'match_odds')">
                            <b>
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.price ? oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.price : '-'}}
                            <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.size ? volumeMultiSize(oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.size, data?.event?.match_odds?.volume_multi) : '-'}}</span>
                            </b>
                        </button>
                        <button class="{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.key}} back" (click)="openBetPlace(data?.event?.match_odds, oddsLisDis[data?.event?.match_odds?.market_id], i, oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0], '0', 'b3', 'match_odds')">
                            <b>
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.price ? oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.price : '-'}}
                            <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.size ? volumeMultiSize(oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.size, data?.event?.match_odds?.volume_multi) : '-'}}</span>
                            </b>
                        </button>
                        <button class="{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.key}} lay lay" (click)="openBetPlace(data?.event?.match_odds, oddsLisDis[data?.event?.match_odds?.market_id], i, oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0], '0', 'l1', 'match_odds')">
                            <b>
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.price ? oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.price : '-'}}
                            <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.size ? volumeMultiSize(oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.size, data?.event?.match_odds?.volume_multi) : '-'}}</span>
                            </b>
                        </button>
                        <button class="{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.key}} lay lay1" (click)="openBetPlace(data?.event?.match_odds, oddsLisDis[data?.event?.match_odds?.market_id], i, oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1], '1', 'l2', 'match_odds')">
                            <b>
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.price ? oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.price : '-'}}
                            <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.size ? volumeMultiSize(oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.size, data?.event?.match_odds?.volume_multi) : '-'}}</span>
                            </b>
                        </button>
                        <button class="{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.key}} lay lay2" (click)="openBetPlace(data?.event?.match_odds, oddsLisDis[data?.event?.match_odds?.market_id], i, oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2], '2', 'l3', 'match_odds')">
                            <b>
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.price ? oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.price : '-'}}
                            <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.size ? volumeMultiSize(oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.size, data?.event?.match_odds?.volume_multi) : '-'}}</span>
                            </b>
                        </button>
                
                        <div class="suspended"
                            *ngIf="oddsLisDis[data?.event?.match_odds?.market_id] && oddsLisDis[data?.event?.match_odds?.market_id]?.status != 'OPEN' && oddsLisDis[data?.event?.match_odds?.market_id]?.status != 'CLOSE'">
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.status}}</div>
                        <div class="suspended"
                            *ngIf="oddsLisDis[data?.event?.match_odds?.market_id] && oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.status != '' && oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.status != 'ACTIVE' && (oddsLisDis[data?.event?.match_odds?.market_id]?.status == 'OPEN' || oddsLisDis[data?.event?.match_odds?.market_id]?.status == 'CLOSE')">
                            {{oddsLisDis[data?.event?.match_odds?.market_id]?.cRunners[runner?.selection_id]?.status}}
                        </div>
                        <div class="suspended" *ngIf="data?.event?.match_odds?.bet_allow == 0"></div>
                    </div>
                </div>
            </div>

            <!-- message -->
            <div class="row mx-0 odds_body"
                *ngIf="oddsLisDis[data?.event?.match_odds?.market_id]?.message != null && oddsLisDis[data?.event?.match_odds?.market_id]?.message != ''">
                <div class="fancy_message"> <span>{{oddsLisDis[data?.event?.match_odds?.market_id]?.message}}</span></div>
            </div>
            <div class="row mx-0 odds_body" *ngIf="!oddsLisDis[data?.event?.match_odds?.market_id] && data?.event?.match_odds.message != null && data?.event?.match_odds.message != ''">
                <div class="fancy_message"> <span>{{data?.event?.match_odds.message}}</span></div>
            </div>
            <!-- /message -->
        </div>
        <!-- MATCH ODDS -->

        <!-- BOOK MAKER -->
        <!-- <div class="dScreen bookmaker_div" *ngIf="data?.event?.book_makers.length > 0"> -->
            <div *ngIf="data?.event?.book_makers.length > 0">
                <div *ngFor="let bmItem of data?.event?.book_makers;let bi=index;trackBy:trackByIndex;">
                    <div *ngIf="bmItem.status == 1">
                        <div class="dScreen">
                            <div class="row mx-0 head_bg">
                                <div class="col-md-6 col-9 px-0">
                                    <p class="match-odds">
                                        <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(bmItem?.market_id)" (click)="multiMarketUpdate(bmItem, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                                        <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(bmItem?.market_id)" (click)="multiMarketUpdate(bmItem, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                                        {{bmItem?.title}}
                                        <a href="javascript:void(0)" (click)="openModal(ruleModal, 'rule')">
                                            <i class="mdi mdi-information-outline"></i>
                                        </a>
                                        <a href="javascript:void(0)" class="setting" *ngIf="env.host.isMarketSetting" (click)="openSettingModal(bmItem)">
                                            <i class="mdi mdi-cog"></i>
                                        </a>
                                        <a href="javascript:void(0)" class="book" *ngIf="exposLisDis[bmItem?.market_id]"
                                            (click)="openBook(bmItem, 'bookmaker')">
                                            <i class="mdi mdi-book"></i>
                                        </a>
                                    </p>
                                </div>
                                <div class="col-md-4 col text-end px-0">
                                    <span class="matched-count" *ngIf="oddsLisDis[bmItem?.market_id]?.totalMatched">Matched
                                        <strong>{{oddsLisDis[bmItem?.market_id]?.totalMatched}}</strong></span>
                                </div>
                            </div>
                            <div class="row mx-0 odds_header">
                                <div class="col-md-5 col-7 px-0">
                                    <div class="minmax mm-fi">
                                        <dl class="fancy-info">
                                            <dt>Min/Max</dt>
                                            <dd>{{bmItem?.min_bet}}-{{bmItem?.max_bet}}</dd>
                                        </dl>
                                    </div>
                                </div>
                                <div class="col-md-7 col-5 px-0">
                                    <div class="btn-group dOddsBox">
                                        <button class="back2"></button>
                                        <button class="back1"></button>
                                        <button class="back">back</button>
                                        <button class="lay">lay</button>
                                        <button class="min-max-bet">
                                            <dl class="fancy-info">
                                                <dt>Min/Max</dt>
                                                <dd>{{bmItem?.min_bet}}-{{bmItem?.max_bet}}
                                                </dd>
                                            </dl>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row mx-0 odds_body"
                                *ngFor="let item of bmItem?.book_maker_odds; let i=index;trackBy:trackByIndex;">
                                <div class="col-md-5 col-7 px-0">
                                    <p class="team-name">
                                        {{item?.name}}
                                        <span *ngIf="exposLisDis[bmItem?.market_id] && exposLisDis[bmItem?.market_id][item?.selection_id]"
                                        [ngClass]="exposLisDis[bmItem?.market_id][item?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'"><i
                                            class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[bmItem?.market_id][item?.selection_id].expose)}}
                                        {{(exposLisDis[bmItem?.market_id][item?.selection_id].average &&
                                        exposLisDis[bmItem?.market_id][item?.selection_id].average != '') ?
                                        exposLisDis[bmItem?.market_id][item?.selection_id].average : ''}}</span>
                                        <!-- <span *ngIf="!(exposLisDis[bmItem?.market_id] && exposLisDis[bmItem?.market_id][item?.selection_id])" class="minus-book"><i
                                            class="mdi mdi-arrow-right"></i> 0.00</span> -->
                                        <!-- <span *ngIf="nextExpoList[bmItem?.market_id+'-'+ item?.selection_id]">
                                        <span
                                            [ngClass]="{'plus-book': nextExpoList[bmItem?.market_id+'-'+ item?.selection_id] > 0, 'minus-book': nextExpoList[bmItem?.market_id+'-'+ item?.selection_id] < 0}">({{nextExpoList[bmItem?.market_id+'-'+
                                            item?.selection_id]}})</span></span> -->
                                        <span *ngIf="nextExpoList[bmItem?.market_id+'-'+ item?.selection_id]">
                                            <span
                                                [ngClass]="{'plus-book': nextExpoList[bmItem?.market_id+'-'+ item?.selection_id] > 0, 'minus-book': nextExpoList[bmItem?.market_id+'-'+ item?.selection_id] < 0}">({{nextExpoList[bmItem?.market_id+'-'+
                                                item?.selection_id]}})</span></span>
                                    </p>
                                </div>
                                <div class="col-md-7 col-5 px-0">
                                    <div class="btn-group dOddsBox">
                                        <button class="{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.bKey2}} back  back2" (click)="openBetPlace(bmItem, oddsLisDis[bmItem?.market_id], i, oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id],'2', 'b1', 'book_makers')">
                                            <b>
                                                {{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back2 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back2 : '-'}}
                                                <span>{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back_volume2 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back_volume2 :'-'}}</span>
                                            </b>
                                        </button>
                                        <button class="{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.bKey1}} back back1" (click)="openBetPlace(bmItem, oddsLisDis[bmItem?.market_id], i, oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id], '1', 'b2', 'book_makers')"> 
                                            <b>
                                                {{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back1 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back1 : '-'}}
                                                <span>{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back_volume1 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back_volume1 : '-'}}</span>
                                            </b>
                                        </button>
                                        <button class="{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.bKey}} back" (click)="openBetPlace(bmItem, oddsLisDis[bmItem?.market_id], i, oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id], '', 'b3', 'book_makers')">
                                            <b>
                                                {{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back : '-'}}
                                                <span>{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back_volume ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.back_volume : '-'}}</span>
                                            </b>
                                        </button>
                                        <button class="{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lKey}} lay lay" (click)="openBetPlace(bmItem, oddsLisDis[bmItem?.market_id], i, oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id], '', 'l1', 'book_makers')">
                                            <b>
                                                {{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay : '-'}}
                                                <span>{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay_volume ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay_volume : '-'}}</span>
                                            </b>
                                        </button>
                                        <button class="{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lKey1}} lay lay1" (click)="openBetPlace(bmItem, oddsLisDis[bmItem?.market_id], i, oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id], '1', 'l2', 'book_makers')">
                                            <b>
                                                {{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay1 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay1 : '-'}}
                                                <span>{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay_volume1 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay_volume1 : '-'}}</span>
                                            </b>
                                        </button>
                                        <button class="{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lKey2}} lay lay2" (click)="openBetPlace(bmItem, oddsLisDis[bmItem?.market_id], i, oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id], '2', 'l3', 'book_makers')">
                                            <b>
                                                {{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay2 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay2 : '-'}}
                                                <span>{{oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay_volume2 ? oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.lay_volume2 : '-'}}</span>
                                            </b>
                                        </button>
                                        <div class="suspended"
                                            *ngIf="oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.suspended == 1 || oddsLisDis[bmItem?.market_id]?.cRunners[item?.selection_id]?.ball_running == 1 || oddsLisDis[bmItem?.market_id]?.bet_allow == 0">
                                            suspended</div>
                                        <!-- <div class="suspended" *ngIf="oddsLisDis[bmItem?.market_id]?.bet_allow == 0"> suspended</div> -->
                                    </div>
                                </div>
                                
                            </div>

                            <!-- message -->
                            <div class="row mx-0 odds_body" *ngIf="oddsLisDis[bmItem?.market_id]?.message != null && oddsLisDis[bmItem?.market_id]?.message != ''">
                                <div class="fancy_message"> <span>{{oddsLisDis[bmItem?.market_id]?.message}}</span></div>
                            </div>
                            <div class="row mx-0 odds_body" *ngIf="!oddsLisDis[bmItem?.market_id] && bmItem.message != null && bmItem.message != ''">
                                <div class="fancy_message"> <span>{{bmItem.message}}</span></div>
                            </div>
                            <!-- /message -->
                        </div>
                    </div>
                </div>
            </div>
        <!-- BOOK MAKER -->

        <!-- LINE -->
        <div class="dScreen fancy_odds" *ngIf="data?.event?.fancy.length > 0 && fLineMrk">
            <div class="row mx-0 head_bg">
                <div class="col-md-6 col-7 px-0">
                    <p class="match-odds">Line <i class="mdi mdi-information-outline"></i></p>
                    <!-- <a href="" class="add-pins">
                        <img class="img-fluid" src="assets/img/pin-white.svg">
                        <img class="img-fluid" src="assets/img/pin-green.svg">
                    </a> -->
                </div>
                <!-- <div class="col-md-6 col-4 text-end px-0">
                    <span class="matched-count">Matched <strong>{{oddsLisDis[item?.market_id]?.totalMatched}}</strong></span>
                </div> -->
            </div>
            <div class="row mx-0 odds_header">
                <div class="col-md-5 col-9 px-0">
                </div>
                <div class="col-md-7 col px-0">
                    <div class="btn-group dOddsBox">
                        <button class="lay2"></button>
                        <button class="lay1"></button>
                        <button class="lay">no</button>
                        <button class="back">yes</button>
                        <button class="min-max-bet">Min-Max</button>
                    </div>
                </div>
            </div>
            <div *ngFor="let item of data?.event?.fancy; let i=index;trackBy:trackByIndex;">
                <div class="row mx-0 odds_body" *ngIf="item.fancy_type == 'LINE'">
                    <div class="col-md-5 col-7 px-0">
                        <p class="team-name">
                        <a href="javascript:void(0)" class="fancy-cs setting" *ngIf="env.host.isMarketSetting" (click)="openSettingModal(item)">
                            <i class="mdi mdi-cog"></i>
                        </a>
                        <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                        <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                        <b>
                            {{item.name}}
                            <span *ngIf="exposLisDis[item?.market_id] && exposLisDis[item?.market_id][item?.selection_id]"
                            [ngClass]="exposLisDis[item?.market_id][item?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'" (click)="fancyRunPosition(fancyRunModal, item)"><i
                                    class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[item?.market_id][item?.selection_id]?.expose)}}</span>
                            <!-- <span *ngIf="!(exposLisDis[item?.market_id] && exposLisDis[item?.market_id][item?.selection_id])" class="minus-book"><i class="mdi mdi-arrow-right"></i>
                                0.00</span> -->
                            </b>
                        </p>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="back back2"></button>
                            <button class="back back1">
                                <a class="book" hef="javascript:void(0)" *ngIf="exposLisDis[item?.market_id] && exposLisDis[item?.market_id][item?.selection_id]"
                                    (click)="fancyRunPosition(fancyRunModal, item)">book</a>
                            </button>
                            <div class="back-lay-div-parent">
                                <div class="">
                                <button class="{{oddsLisDis[item?.market_id]?.lKey}} lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '', oddsLisDis[item?.market_id], '', 'l3', 'fancy')">
                                    {{oddsLisDis[item?.market_id]?.lay_price ? oddsLisDis[item?.market_id]?.lay_price : '-'}} 
                                    <span>{{oddsLisDis[item?.market_id]?.lay_rate ? oddsLisDis[item?.market_id]?.lay_rate : '-'}}</span>
                                </button>
                                <button class="{{oddsLisDis[item?.market_id]?.bKey}} back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '', oddsLisDis[item?.market_id], '', 'b1', 'fancy')">
                                    {{oddsLisDis[item?.market_id]?.back_price ? oddsLisDis[item?.market_id]?.back_price : '-'}} 
                                    <span>{{oddsLisDis[item?.market_id]?.back_rate ? oddsLisDis[item?.market_id]?.back_rate : '-'}}</span>
                                </button>
                                </div>
                                <div class="back-lay-div" *ngIf="oddsLisDis[item?.market_id]?.active_rate1 == 1">
                                <button class="{{oddsLisDis[item?.market_id]?.lKey1}} lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '1', oddsLisDis[item?.market_id], '1', 'l2', 'fancy')">
                                    {{oddsLisDis[item?.market_id]?.lay1_price ? oddsLisDis[item?.market_id]?.lay1_price : '-'}} 
                                    <span>{{oddsLisDis[item?.market_id]?.lay1_rate ? oddsLisDis[item?.market_id]?.lay1_rate : '-'}}</span>
                                </button>
                                <button class="{{oddsLisDis[item?.market_id]?.bKey1}} back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '1', oddsLisDis[item?.market_id], '1', 'b2', 'fancy')">
                                    {{oddsLisDis[item?.market_id]?.back1_price ? oddsLisDis[item?.market_id]?.back1_price : '-'}} 
                                    <span>{{oddsLisDis[item?.market_id]?.back1_rate ? oddsLisDis[item?.market_id]?.back1_rate : '-'}}</span>
                                </button>
                                </div>
                                <div class="back-lay-div" *ngIf="oddsLisDis[item?.market_id]?.active_rate2 == 1">
                                <button class="{{oddsLisDis[item?.market_id]?.lKey2}} lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '2', oddsLisDis[item?.market_id], '2', 'l1', 'fancy')">
                                    {{oddsLisDis[item?.market_id]?.lay2_price ? oddsLisDis[item?.market_id]?.lay2_price : '-'}} 
                                    <span>{{oddsLisDis[item?.market_id]?.lay2_rate ? oddsLisDis[item?.market_id]?.lay2_rate : '-'}}</span>
                                </button>
                                <button class="{{oddsLisDis[item?.market_id]?.bKey2}} back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '2', oddsLisDis[item?.market_id], '2', 'b3', 'fancy')">
                                    {{oddsLisDis[item?.market_id]?.back2_price ? oddsLisDis[item?.market_id]?.back2_price : '-'}} 
                                    <span>{{oddsLisDis[item?.market_id]?.back2_rate ? oddsLisDis[item?.market_id]?.back2_rate : '-'}}</span>
                                </button>
                                </div>
                            </div>
                            <button class="min-max-bet">
                                <dl class="fancy-info">
                                    <dd>{{item?.min_bet}}-{{item?.max_bet}}</dd>
                                </dl>
                            </button>
                            <div class="suspended" *ngIf="oddsLisDis[item?.market_id]?.suspended == 1">suspended</div>
                            <div class="suspended" *ngIf="oddsLisDis[item?.market_id]?.suspended == 0 && oddsLisDis[item?.market_id]?.ball_running == 1">ball running
                            </div>
                            <div class="suspended" *ngIf="item?.bet_allow == 0"></div>
                        </div>
                    </div>

                    <!-- message -->
                    <div class="fancy_message" *ngIf="item.fancy_type == 'LINE' && oddsLisDis[item?.market_id]?.message != null && oddsLisDis[item?.market_id]?.message != ''"> <span>{{oddsLisDis[item?.market_id]?.message}}</span></div>
                    <!-- /message -->
                </div>
            </div>
        </div>
        <!-- LINE -->

        <!-- FANCY -->
        <div class="dScreen fancy_odds" *ngIf="data?.event?.fancy.length > 0 && fFancyMrk">
            <div class="row mx-0 head_bg">
                <div class="col-md-6 col px-0">
                    <p class="match-odds">fancy <i class="mdi mdi-information-outline"></i></p>
                </div>
                <!-- <div class="col-md-6 col-4 text-end px-0">
                    <span class="matched-count">Matched <strong>{{oddsLisDis[item?.market_id]?.totalMatched}}</strong></span>
                </div> -->
            </div>
            <tabset type="nav de_fancyTab">
                <tab *ngFor="let tab of fancyTab | keyvalue" id="tab1">
                  <ng-template tabHeading>
                    <span style="text-transform: uppercase;">{{tab.key}}</span>
                  </ng-template>
                  <div  *ngIf="!isCommon(tab.value,fancyTab['all'])">
                    <div class="row mx-0 odds_header">
                        <div class="col-md-5 col-7 px-0">
                        </div>
                        <div class="col-md-7 col px-0">
                            <div class="btn-group dOddsBox">
                                <button class="lay2"></button>
                                <button class="lay1"></button>
                                <button class="lay">no</button>
                                <button class="back">yes</button>
                                <button class="min-max-bet">Min-Max</button>
                            </div>
                        </div>
                    </div>
            
                    <!-- start -->
                    <div *ngFor="let item of data?.event?.fancy; let i=index;trackBy:trackByIndex;">
                      <!-- ------------{{item?.sort_priority}}---------------------{{tab.value}} -->
                      <div *ngIf="isInclude(tab.value, item?.sort_priority)">
                        <div class="row mx-0 odds_body" *ngIf="item.fancy_type != 'LINE'">
                            <div class="col-md-5 col-7 px-0">
                                <p class="team-name">
                                <a href="javascript:void(0)" class="fancy-cs setting" *ngIf="env.host.isMarketSetting" (click)="openSettingModal(item)">
                                    <i class="mdi mdi-cog"></i>
                                </a>
                                <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                                <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                                    <b>
                                        {{item.name}}
                                        <span *ngIf="exposLisDis[item?.market_id] && exposLisDis[item?.market_id][item?.selection_id]"
                                        [ngClass]="exposLisDis[item?.market_id][item?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'" (click)="fancyRunPosition(fancyRunModal, item)"><i
                                                class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[item?.market_id][item?.selection_id]?.expose)}}</span>
                                        <!-- <span *ngIf="!(exposLisDis[item?.market_id] && exposLisDis[item?.market_id][item?.selection_id])" class="minus-book"><i class="mdi mdi-arrow-right"></i>0.00</span> -->
                                    </b>
                                </p>
                            </div>
                            <div class="col-md-7 col-5 px-0">
                                <div class="btn-group dOddsBox">
                                    <button class="back back2"></button>
                                    <button class="back back1">
                                        <a class="book" hef="javascript:void(0)" *ngIf="exposLisDis[item?.market_id] && exposLisDis[item?.market_id][item?.selection_id]"
                                            (click)="fancyRunPosition(fancyRunModal, item)">book</a>
                                    </button>
                                    <div class="back-lay-div-parent">
                                        <div class="">
                                        <button class="{{oddsLisDis[item?.market_id]?.lKey}} lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '', oddsLisDis[item?.market_id], '', 'l3', 'fancy')">
                                            {{oddsLisDis[item?.market_id]?.lay_price ? oddsLisDis[item?.market_id]?.lay_price : '-'}} 
                                            <span>{{oddsLisDis[item?.market_id]?.lay_rate ? oddsLisDis[item?.market_id]?.lay_rate : '-'}}</span>
                                        </button>
                                        <button class="{{oddsLisDis[item?.market_id]?.bKey}} back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '', oddsLisDis[item?.market_id], '', 'b1', 'fancy')">
                                            {{oddsLisDis[item?.market_id]?.back_price ? oddsLisDis[item?.market_id]?.back_price : '-'}} 
                                            <span>{{oddsLisDis[item?.market_id]?.back_rate ? oddsLisDis[item?.market_id]?.back_rate : '-'}}</span>
                                        </button>
                                        </div>
                                        <div class="back-lay-div" *ngIf="oddsLisDis[item?.market_id]?.active_rate1 == 1">
                                        <button class="{{oddsLisDis[item?.market_id]?.lKey1}} lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '1', oddsLisDis[item?.market_id], '1', 'l2', 'fancy')">
                                            {{oddsLisDis[item?.market_id]?.lay1_price ? oddsLisDis[item?.market_id]?.lay1_price : '-'}} 
                                            <span>{{oddsLisDis[item?.market_id]?.lay1_rate ? oddsLisDis[item?.market_id]?.lay1_rate : '-'}}</span>
                                        </button>
                                        <button class="{{oddsLisDis[item?.market_id]?.bKey1}} back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '1', oddsLisDis[item?.market_id], '1', 'b2', 'fancy')">
                                            {{oddsLisDis[item?.market_id]?.back1_price ? oddsLisDis[item?.market_id]?.back1_price : '-'}} 
                                            <span>{{oddsLisDis[item?.market_id]?.back1_rate ? oddsLisDis[item?.market_id]?.back1_rate : '-'}}</span>
                                        </button>
                                        </div>
                                        <div class="back-lay-div" *ngIf="oddsLisDis[item?.market_id]?.active_rate2 == 1">
                                        <button class="{{oddsLisDis[item?.market_id]?.lKey2}} lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '2', oddsLisDis[item?.market_id], '2', 'l1', 'fancy')">
                                            {{oddsLisDis[item?.market_id]?.lay2_price ? oddsLisDis[item?.market_id]?.lay2_price : '-'}} 
                                            <span>{{oddsLisDis[item?.market_id]?.lay2_rate ? oddsLisDis[item?.market_id]?.lay2_rate : '-'}}</span>
                                        </button>
                                        <button class="{{oddsLisDis[item?.market_id]?.bKey2}} back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], '2', oddsLisDis[item?.market_id], '2', 'b3', 'fancy')">
                                            {{oddsLisDis[item?.market_id]?.back2_price ? oddsLisDis[item?.market_id]?.back2_price : '-'}} 
                                            <span>{{oddsLisDis[item?.market_id]?.back2_rate ? oddsLisDis[item?.market_id]?.back2_rate : '-'}}</span>
                                        </button>
                                        </div>
                                    </div>
                                    <!-- <button class="{{oddsLisDis[item?.market_id]?.lKey}} back" *ngIf="oddsLisDis[item?.market_id]?.active_rate == 1"
                                        (click)="openBetPlace(item, oddsLisDis[item?.market_id], '', oddsLisDis[item?.market_id], '', 'l3', 'fancy')">{{oddsLisDis[item?.market_id]?.lay_price
                                        ? oddsLisDis[item?.market_id]?.lay_price :
                                        '-'}} <span>{{oddsLisDis[item?.market_id]?.lay_rate ? oddsLisDis[item?.market_id]?.lay_rate :
                                            '-'}}</span></button>
                                    <button class="{{oddsLisDis[item?.market_id]?.bKey}} lay lay" *ngIf="oddsLisDis[item?.market_id]?.active_rate == 1"
                                        (click)="openBetPlace(item, oddsLisDis[item?.market_id], '', oddsLisDis[item?.market_id], '', 'b1', 'fancy')">{{oddsLisDis[item?.market_id]?.back_price
                                        ? oddsLisDis[item?.market_id]?.back_price :
                                        '-'}} <span>{{oddsLisDis[item?.market_id]?.back_rate ? oddsLisDis[item?.market_id]?.back_rate :
                                            '-'}}</span></button> -->
                                    <button class="min-max-bet">
                                        <dl class="fancy-info">
                                            <dd>{{item?.min_bet}}-{{item?.max_bet}}</dd>
                                        </dl>
                                    </button>
                                    <div class="suspended" *ngIf="oddsLisDis[item?.market_id]?.suspended == 1">suspended</div>
                                    <div class="suspended" *ngIf="oddsLisDis[item?.market_id]?.suspended == 0 && oddsLisDis[item?.market_id]?.ball_running == 1">ball running
                                    </div>
                                    <div class="suspended" *ngIf="item?.bet_allow == 0"></div>
                                </div>
                            </div>

                            <!-- message -->
                            <div class="fancy_message" *ngIf="item.fancy_type != 'LINE' && oddsLisDis[item?.market_id]?.message != null && oddsLisDis[item?.market_id]?.message != ''"> <span>{{oddsLisDis[item?.market_id]?.message}}</span></div>
                            <!-- /message -->
                            
                        </div>
                      </div>
                    </div>
                    <!-- end -->
                  </div>
            
                  <div *ngIf="isCommon(tab.value,fancyTab['all'])">No Data found</div>
                </tab>
              </tabset>
        </div>
        <!-- FANCY -->

        <!-- MARKET -->
        <div *ngFor="let item of data?.event?.markets; let i=index; trackBy:trackByIndex;">
            <div class="dScreen" *ngIf="(item.market_type_id != 'MATCH_ODDS' && item.status != 4) && (mId == null || mId == item.market_id)">
                <div class="row mx-0 head_bg">
                    <div class="col-md-6 col-9 px-0">
                        <p class="match-odds">
                            <a href="javascript:void(0);" class="add-pins" *ngIf="multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'remove')"> <img class="img-fluid" src="assets/img/pin-green.svg"> </a>
                            <a href="javascript:void(0);" class="add-pins" *ngIf="!multiMarketIds.includes(item?.market_id)" (click)="multiMarketUpdate(item, 'save')"> <img class="img-fluid" src="assets/img/pin-white.svg"> </a>
                            {{item.market_name}}
                            <a href="javascript:void(0)" (click)="openModal(ruleModal, 'rule')">
                                <i class="mdi mdi-information-outline"></i>
                            </a>
                            <span *ngIf="data?.event?.event?.event_type_id == '7' || data?.event?.event?.event_type_id == '4339'">
                                <button class="btn-cashout" *ngIf="!item?.bet_open && raceTimer && raceTimer != ''">{{raceTimer}}</button>
                                <button class="btn-cashout" *ngIf="item?.bet_open && (oddsLisDisNew[item?.market_id]?.inplay == '' || oddsLisDisNew[item?.market_id]?.inplay == 0)">Betting Open</button>
                                <button class="btn-cashout" *ngIf="oddsLisDisNew[item?.market_id]?.inplay == 1">In Play</button>
                            </span>

                            <a href="javascript:void(0)" class="setting" *ngIf="env.host.isMarketSetting" (click)="openSettingModal(item)">
                                <i class="mdi mdi-cog"></i>
                            </a>

                            <a href="javascript:void(0)" class="book" *ngIf="exposLisDis[item?.market_id]" (click)="openBook(item, 'odds')">
                                <i class="mdi mdi-book"></i>
                            </a>
                        </p>
                    </div>
                    <div class="col-md-4 col text-end px-0">
                        <span class="matched-count">Matched
                            <strong>{{oddsLisDis[item?.market_id]?.totalMatched}}</strong></span>
                    </div>
                </div>
                <div class="row mx-0 odds_header">
                    <div class="col-md-5 col-7 px-0">
                        <div class="minmax mm-fi">
                            <dl class="fancy-info">
                                <dt>Min/Max</dt>
                                <dd>{{item?.min_bet}}-{{item?.max_bet}}</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="back2"></button>
                            <button class="back1"></button>
                            <button class="back">back</button>
                            <button class="lay">lay</button>
                            <button class="min-max-bet">
                                <dl class="fancy-info">
                                    <dt>Min/Max</dt>
                                    <dd>{{item?.min_bet}}-{{item?.max_bet}}</dd>
                                </dl>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row mx-0 odds_body"
                    *ngFor="let runner of item?.runners; let ri=index;trackBy:trackByIndex;">
                    <div class="col-md-5 col-7 px-0">
                        <p class="team-name">
                            <!-- Jockey detail for horse racing -->
                        <img class="jockey-img" src="{{env.horseRaceJockeyImgPrefix + runner?.meta_data?.COLOURS_FILENAME}}" *ngIf="data?.event?.event?.event_type_id == 7">
                            {{runner?.name}}

                            <!-- Jockey detail for horse racing -->
                            <span class="jockey-detail mt-1 mb-1" *ngIf="data?.event?.event?.event_type_id == 7 || data?.event?.event?.event_type_id == 4339">
                                <span class="horse-attr"><b>Jockey:</b> {{runner?.meta_data?.JOCKEY_NAME}}</span>
                                <span class="horse-attr"><b>Trainer:</b> {{runner?.meta_data?.TRAINER_NAME}}</span>
                                <span class="horse-attr"><b>Age:</b> {{runner?.meta_data?.AGE}}</span>
                              </span>
                              
                            <span *ngIf="exposLisDis[runner?.market_id] && exposLisDis[runner?.market_id][runner?.selection_id]"
                            [ngClass]="exposLisDis[runner?.market_id][runner?.selection_id]?.expose > 0 ? 'plus-book' : 'minus-book'"><i
                                    class="mdi mdi-arrow-right"></i> {{fixedPostDecimal(exposLisDis[runner?.market_id][runner?.selection_id]?.expose)}}
                                {{(exposLisDis[runner?.market_id][runner?.selection_id]?.average && exposLisDis[runner?.market_id][runner?.selection_id]?.average != '') ?
                                exposLisDis[runner?.market_id][runner?.selection_id]?.average : ''}}</span>
                            <!-- <span *ngIf="!(exposLisDis[runner?.market_id] && exposLisDis[runner?.market_id][runner?.selection_id])" class="minus-book"><i class="mdi mdi-arrow-right"></i>
                                0.00</span> -->
                            <span *ngIf="nextExpoList[item?.market_id+'-'+ runner?.selection_id]"> <span
                                    [ngClass]="{'plus-book': nextExpoList[item?.market_id+'-'+ runner?.selection_id] > 0, 'minus-book': nextExpoList[item?.market_id+'-'+ runner?.selection_id] < 0}">({{nextExpoList[item?.market_id+'-'+
                                    runner?.selection_id]}})</span></span>
                        </p>
                    </div>
                    <div class="col-md-7 col-5 px-0">
                        <div class="btn-group dOddsBox">
                            <button class="back  back2" (click)="openBetPlace(item, oddsLisDis[item?.market_id], ri, oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2], '2', 'b1', 'match_odds')">
                                <b>
                                    {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.price ? oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.price : '-'}}
                                    <span>{{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.size ? volumeMultiSize(oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[2]?.size, item?.volume_multi) : '-'}}</span>
                                </b>
                            </button>
                            <button class="back back1" (click)="openBetPlace(item, oddsLisDis[item?.market_id], ri, oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1], '1', 'b2', 'match_odds')">
                                <b>
                                    {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.price ? oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.price : '-'}}
                                    <span>{{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.size ? volumeMultiSize(oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[1]?.size, item?.volume_multi) : '-'}}</span>
                                </b>
                            </button>
                            <button class="back" (click)="openBetPlace(item, oddsLisDis[item?.market_id], ri, oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0], '0', 'b3', 'match_odds')">
                                <b>
                                    {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.price ? oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.price : '-'}}
                                    <span>{{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.size ? volumeMultiSize(oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToBack[0]?.size, item?.volume_multi) : '-'}}</span>
                                </b>
                            </button>
                            <button class="lay lay" (click)="openBetPlace(item, oddsLisDis[item?.market_id], ri, oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0], '0', 'l1', 'match_odds')">
                                <b>
                                    {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.price ? oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.price : '-'}}
                                    <span>{{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.size ? volumeMultiSize(oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[0]?.size, item?.volume_multi) : '-'}}</span>
                                </b>
                            </button>
                            <button class="lay lay1" (click)="openBetPlace(item, oddsLisDis[item?.market_id], ri, oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1], '1', 'l2', 'match_odds')">
                                <b>
                                    {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.price ? oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.price : '-'}}
                                    <span>{{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.size ? volumeMultiSize(oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[1]?.size, item?.volume_multi) : '-'}}</span>
                                </b>
                            </button>
                            <button class="lay lay2" (click)="openBetPlace(item, oddsLisDis[item?.market_id], ri, oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2], '2', 'l3', 'match_odds')">
                                <b>
                                    {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.price ? oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.price : '-'}}
                                    <span>{{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.size ? volumeMultiSize(oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.ex?.availableToLay[2]?.size, item?.volume_multi) : '-'}}</span>
                                </b>
                            </button>
                        
                            <div class="suspended"
                                *ngIf="oddsLisDis[item?.market_id] && oddsLisDis[item?.market_id]?.status != 'OPEN' && oddsLisDis[item?.market_id]?.status != 'CLOSE'">
                                {{oddsLisDis[item?.market_id]?.status}}</div>
                            <div class="suspended"
                                *ngIf="oddsLisDis[item?.market_id] && oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.status != '' && oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id]?.status != 'ACTIVE' && (oddsLisDis[item?.market_id]?.status == 'OPEN' || oddsLisDis[item?.market_id]?.status == 'CLOSE')">
                                {{oddsLisDis[item?.market_id]?.cRunners[runner?.selection_id].status}}
                            </div>
                            <div class="suspended" *ngIf="item?.bet_allow == 0"></div>
                        </div>
                    </div>
                    
                </div>

                <!-- message -->
                <div class="row mx-0 odds_body" *ngIf="oddsLisDis[item?.market_id]?.message != null && oddsLisDis[item?.market_id]?.message != ''">
                    <div class="fancy_message"> <span>{{oddsLisDis[item?.market_id]?.message}}</span></div>
                </div>
                <div class="row mx-0 odds_body" *ngIf="!oddsLisDis[item?.market_id] && item.message != null && item.message != ''">
                    <div class="fancy_message"> <span>{{item.message}}</span></div>
                </div>
                <!-- /message -->
            </div>
        </div>
        <!-- MARKET -->
    </div> <!-- end col -->

    <div class="col-md-3">
        <div class="openBets">
            <div class="collapse" id="collapseSetting">
                <app-stakes></app-stakes>
            </div>
            <!-- tv desktop -->
            <!-- <div id="collapseBasic" [collapse]="isCollapsed.tv.desktop" [isAnimated]="true">
                <div id="tvStr" class="embed-responsive embed-responsive-16by9 rounded" [innerHTML]="tvSteam | safeHtml"></div>
            </div> -->
            <!-- tv desktop -->
            
            <!-- tv desktop -->
            <div id="collapseBasic" [collapse]="isCollapsed.tv.desktop" [isAnimated]="true">
              <!-- <div class="tv-block" *ngIf="isCollapsed.tv.desktop == false" style="position:relative;">
                  <iframe class="LiveStream-video-col" id="tvStr" [src]='iframeURL | safeURL'></iframe>
              </div> -->
              <div id="tv-block-id-desk" style="position: relative;" class="tv-block"></div>
            </div>
            <!-- tv desktop -->

            <h2>open bets
                <!-- <a class="desk-tv-icon" href="javascript:void(0)" (click)="tvData('desktop')" [attr.aria-expanded]="!isCollapsed.tv.desktop" aria-controls="collapseBasic">
                    <i class="mdi mdi-television"></i>
                </a> -->
                <a class="desk-tv-icon" href="javascript:void(0)" (click)="tvData('desktop')"
                    [attr.aria-expanded]="!isCollapsed.tv.desktop" aria-controls="collapseBasic">
                    <!-- <img class="img-fluid" src="assets/img/television.png"> -->
                    <i class="mdi mdi-television"></i>
                </a>
            </h2>
            <app-bet-list></app-bet-list>
        </div> <!-- end card-->
    </div> <!-- end col -->

</div>


<ng-template #ruleModal>
    <div class="modal-header d-block text-center m-0">
        <h4 class="modal-title">Rules Of Cricket</h4>
        <!-- <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button> -->
    </div>
    <div class="modal-body">
        <p>1. Cricket General :- ➢ If a ball is not bowled during a competition, series or match then all bets will be
            void except for those on any market that has been unconditionally determined (e.g. in the 'Completed Match'
            market).</p>

        <p>2. Cricket General :- If a match is shortened by weather, all bets will be settled according to the official
            result (including for limited overs matches, the result determined by the Duckworth Lewis method).</p>

        <p>3. Cricket General :- In the event of a match being decided by a bowl-off or toss of the coin, all bets will
            be void except for those on markets that have been unconditionally determined.</p>

        <p>4. Cricket Test matches :- If a match starts but is later abandoned for any reason other than weather (which
            may include but is not limited to: dangerous or unplayable wicket or outfield; pitch vandalism; strike or
            boycott; crowd protests/violence; stadium damage; acts of terrorism; and acts of God), Betfair reserves the
            right to
            void all bets, except for those on markets that have been unconditionally determined.</p>

        <p>5. In case anyone is found using 2 different IDs and logging in from same IP his winning in both accounts
            will be cancelled.</p>

        <p>6. Cricket Test matches :- If the match is not scheduled to be completed within five days after the original
            scheduled completion date, then all bets on markets for this event will be void, except for bets on any
            markets that have been unconditionally determined.</p>

        <p>7. Cricket Limited Over matches :- If a match is declared (No Result), bets will be void on all markets for
            the event except for those markets which have been unconditionally determined or where the minimum number of
            overs have been bowled as laid out in the market specific information.</p>

        <p>8. Cricket Limited Over matches :- In the event of a new toss taking place on a scheduled reserve day for a
            limited overs match all bets that were placed after 30 minutes before the original scheduled start of play
            on the first day will be made void. This rule relates to all markets except those that have been
            unconditionally determined (e.g. in the win the toss and toss combination markets).</p>
    </div>
    <div class="modal-footer m-0 d-block text-center p-0 border-top">
        <button type="button" class="btn btn-okay" aria-label="Close" (click)="modalRef?.hide()">ok</button>
    </div>
</ng-template>

<ng-template #fancyRunModal>
    <div class="modal-header">
        <h6 class="modal-title">Book</h6>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="col-md-12">
            <table>
                <thead>
                    <th>Run</th>
                    <th>Amount</th>
                </thead>
                <tbody>
                    <tr *ngFor="let item of fancyRun;trackBy:trackByIndex;">
                        <td>{{item.run}}</td>
                        <td [ngClass]="(item.expose >= 0) ? 'text-green' : 'text-red'">{{item.expose}}</td>
                    </tr>
                </tbody>
                <!-- <tfoot>
                    <tr>
                        <td class="no-data-available" colspan="2">No data!</td>
                    </tr>
                </tfoot> -->
            </table>
        </div>
    </div>
</ng-template>

<ng-template #openBets>
    <div class="modal-header">
        <h3 class="modal-title pull-left" id="">Open Bets</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef!.hide()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body p-0">
        <app-bet-list></app-bet-list>
    </div>
</ng-template>

<!-- book -->

<div id="BookClient" class="modal fade" bsModal #bookModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modalUI">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Book </h5>
        <button type="button" class="close" (click)="bookModal?.hide()">×</button>
      </div>

      <div class="modal-body p-1">
        <div class="table-responsive">
          <table class="table mb-0" *ngIf="bookDetail">
            <thead>
              <!-- match_odds book headers -->
              <tr *ngIf="bookDetail?.header?.runners">
                <th>sr</th>
                <th>username</th>
                <th *ngFor="let item of bookDetail?.header?.runners;trackBy:trackByIndex;">{{item?.name}}</th>
              </tr>
              <!-- match_odds book headers -->

              <!-- bookmaker book headers -->
              <tr *ngIf="bookDetail?.header?.book_maker_odds">
                <th>sr</th>
                <th>username</th>
                <th *ngFor="let item of bookDetail?.header?.book_maker_odds;trackBy:trackByIndex;">{{item?.name}}</th>
              </tr>
              <!-- bookmaker book headers -->

            </thead>
            <tbody>
              <tr>
                <td>1</td>

                <td>upline</td>
                <td *ngFor="let item of bookDetail?.own_expose;trackBy:trackByIndex;"
                  [ngClass]="item?.parent_book >= 0 ? 'profit' : 'loss'">{{item?.parent_book}}</td>
              </tr>
              <tr *ngFor="let book of bookDetail?.exposes;let i=index;trackBy:trackByIndex;">
                <td>{{i + 2}}</td>
                <td><a href="javascript:void(0);"
                    (click)="detailPage(book[0]?.user?.id)">{{book[0]?.user?.username}}</a></td>
                <td *ngFor="let item of book;trackBy:trackByIndex;"
                  [ngClass]="item?.parent_book >= 0 ? 'profit' : 'loss'">{{item?.parent_book}}</td>
              </tr>
              <tr>
                <td>{{bookDetail?.exposes?.length + 2}}</td>
                <td>total</td>
                <td *ngFor="let item of bookDetail?.total;trackBy:trackByIndex;"
                  [ngClass]="item >= 0 ? 'profit' : 'loss'">{{item}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- book -->
